import React, { useRef, useEffect } from "react";

const MAX_ROTATE = 10;
const SCALE = 1.03;
const EASE = 0.12;
const REST_THRESHOLD = 0.01; // how close counts as "settled"

const TiltCard = ({ children, className = "" }) => {
  const cardRef = useRef(null);
  const rectRef = useRef(null);
  const target = useRef({ rx: 0, ry: 0, scale: 1 });
  const current = useRef({ rx: 0, ry: 0, scale: 1 });
  const rafId = useRef(null);

  const animate = () => {
    const c = current.current;
    const t = target.current;

    c.rx += (t.rx - c.rx) * EASE;
    c.ry += (t.ry - c.ry) * EASE;
    c.scale += (t.scale - c.scale) * EASE;

    if (cardRef.current) {
      cardRef.current.style.transform = `perspective(1000px) scale(${c.scale}) rotateX(${c.rx}deg) rotateY(${c.ry}deg) translateZ(0px)`;
    }

    const settled =
      Math.abs(t.rx - c.rx) < REST_THRESHOLD &&
      Math.abs(t.ry - c.ry) < REST_THRESHOLD &&
      Math.abs(t.scale - c.scale) < REST_THRESHOLD;

    if (!settled) {
      rafId.current = requestAnimationFrame(animate);
    } else {
      rafId.current = null;
    }
  };

  const ensureLoop = () => {
    if (rafId.current === null) {
      rafId.current = requestAnimationFrame(animate);
    }
  };

  useEffect(() => {
    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, []);

  const handleEnter = () => {
    rectRef.current = cardRef.current.getBoundingClientRect();
    target.current.scale = SCALE;
    ensureLoop();
  };

  const handleMove = (e) => {
    if (!rectRef.current) {
      rectRef.current = cardRef.current.getBoundingClientRect();
    }
    const rect = rectRef.current;
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;

    target.current.ry = (px - 0.5) * MAX_ROTATE * 2;
    target.current.rx = (0.5 - py) * MAX_ROTATE * 2;
    ensureLoop();
  };

  const handleLeave = () => {
    target.current = { rx: 0, ry: 0, scale: 1 };
    rectRef.current = null;
    ensureLoop();
  };

  return (
    <div
      ref={cardRef}
      className={className}
      onMouseEnter={handleEnter}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={{ transformStyle: "preserve-3d" }}
    >
      {children}
    </div>
  );
};

export default TiltCard;